export default __webpack_public_path__ + "static/media/CGTblackIcon.95610f1d.svg";